import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import AgeingFilters from "./components/AgeingFilters";
import AgeingTable from "./components/AgeingTable";
import ReportDom from "../../../components/common/ReportDom";
import { exportAgeingCsv } from "./components/exportAgeingCsv";


const { Title } = Typography;
const { useBreakpoint } = Grid;

const AgeingReport = () => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const screens = useBreakpoint();
 const {
    filters,
    customerList, customerTotalBalance,
    vendorList,   vendorTotalBalance,
  } = useSelector((state) => state.ageing);
  const reportRef = useRef();

  const isCustomer = filters.reportType === "Customer";
  const reportTitle = isCustomer
    ? "Customer Ageing Report"
    : "Vendor Ageing Report";

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: reportTitle,
    removeAfterPrint: true,
  });


  const handleDownloadCsv = () => {
    exportAgeingCsv({
      list:         isCustomer ? customerList  : vendorList,
      totalBalance: isCustomer ? customerTotalBalance : vendorTotalBalance,
      mode:         isCustomer ? "customer" : "vendor",
      title:        reportTitle,
      filename:     isCustomer ? "customer_ageing" : "vendor_ageing",
    });
  };

  const hasData = (isCustomer ? customerList : vendorList).length > 0;
  return (
    <div className="p-4">
      <App>
        {/* Header */}
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate("/reports")}
                style={{ marginRight: 8 }}
              />
              <Title level={4} style={{ margin: 0 }} className="reportBigTitle">
                {reportTitle}
              </Title>
            </div>
          }
          extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        {/* Filters */}
        <AgeingFilters messageApi={message} />

        {/* Ageing Bucket Legend */}
        <Card
          className="mb-3"
          size="small"
          style={{ background: "#fafafa" }}
        >
          <div style={{ display: "flex", gap: 24, flexWrap: "wrap", fontSize: 13 }}>
            <span>
              <span style={{ color: "#52c41a", fontWeight: 700 }}>●</span>{" "}
              Current (0–30 days)
            </span>
            <span>
              <span style={{ color: "#faad14", fontWeight: 700 }}>●</span>{" "}
              31–60 days
            </span>
            <span>
              <span style={{ color: "#fa8c16", fontWeight: 700 }}>●</span>{" "}
              61–90 days
            </span>
            <span>
              <span style={{ color: "#f5222d", fontWeight: 700 }}>●</span>{" "}
              90+ days (overdue)
            </span>
          </div>
        </Card>

        {/* Table */}
        <Card className="shadow-md rounded-xl">
          <AgeingTable mode={isCustomer ? "customer" : "vendor"} />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title={reportTitle}
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <AgeingTable
              mode={isCustomer ? "customer" : "vendor"}
              printMode={true}
            />
          )}
        />
      </div>
    </div>
  );
};

export default AgeingReport;